export default function({ $axios, redirect }) {
  $axios.defaults.timeout = 120000;

  // Global response interceptor to ensure consistent error handling
  $axios.onResponse(response => {
    return response;
  });

  // Global error interceptor to normalize errors and prevent non-Error rejections
  $axios.onError(error => {
    // Ensure we always reject with a proper Error object
    let normalizedError = error;

    // If the error is not an Error instance, create one
    if (!(error instanceof Error)) {
      const errorMessage = typeof error === 'string'
        ? error
        : (error && error.message)
        ? error.message
        : 'Network request failed';

      normalizedError = new Error(errorMessage);
      normalizedError.originalError = error;
      normalizedError.isNormalizedError = true;
    }

    // Add common error metadata
    if (error.response) {
      normalizedError.status = error.response.status;
      normalizedError.statusText = error.response.statusText;
      normalizedError.data = error.response.data;
    }

    // Handle specific status codes
    const code = parseInt(error.response && error.response.status);
    if (code === 403) {
      // Don't redirect here as it might cause navigation issues
      // Let individual pages handle 403 errors
      console.warn('Axios: 403 Forbidden error detected');
    }

    // Always reject with a proper Error object
    return Promise.reject(normalizedError);
  });
}
